/** Breaks storage ↔ moment import cycle: moment registers; storage only imports this file. */

let clearStaleCameraForSeat: (() => void) | null = null;

export function registerClearStaleCameraForSeat(fn: () => void): void {
  clearStaleCameraForSeat = fn;
}

export function clearStaleCameraForSeatContext(): void {
  clearStaleCameraForSeat?.();
}
